<template>
  <div>
    Please try
    <a href="#" @click="reloadPage" class="empty-link-style"
      >refreshing this page</a
    >
    or contact <a href="/contact_us" class="empty-link-style">support</a>.
  </div>
</template>

<script>
export default {
  name: "ErrorStateLinks",
  methods: {
    reloadPage(event) {
      event.preventDefault();
      window.location.reload();
    },
  },
};
</script>
